export enum PortalOrigin {
  Connect = 'connect',
  ConnectAdmin = 'connect-admin',
}

export enum PortalCookie {
  Connect = 'connect.frontend.v2',
  ConnectAdmin = 'connect-admin.frontend.v2',
}
